import React from 'react';
import {
  CreativeOverviewStateContentState,
  CreativeOverviewStateContentProps,
  CreativeOverviewStateContentModel,
} from './CreativeOverviewStateContentModel';
import classNames from 'classnames/bind';
import styles from './creativeOverviewStateContent.module.scss';
import i18n from 'i18next';
import Tags from 'components/Tags/Tags';

import { CreativeList } from './CampaignCreativeList/CreativeList';
import { LoadingIndicator } from 'components/LoadingIndicator';
import { StateDataContext } from 'containers/Common/StateDataContext';
import PermissionChecker from 'containers/PermissionChecker/PermissionChecker';
import { CreativeManagementStateContext } from './CreativeManagementStateContext';
import { Button } from 'react-bootstrap';
import { SearchBar } from 'components/SearchBar';
import { AdType } from 'core/rtbCampaign/RtbCampaign';

export class CreativeOverviewStateContent extends React.Component<
  CreativeOverviewStateContentProps,
  CreativeOverviewStateContentState
> {
  handler: number;
  cssClassNames: any;

  constructor(props) {
    super(props);
    this.cssClassNames = classNames.bind(styles);
    this.handler = this.props.model.event.add((model) => {
      this.setState(model.state);
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.model !== this.props.model) {
      prevProps.model.event.remove(this.handler);
      this.handler = this.props.model.event.add((model) => {
        this.setState(model.state);
      });
    }
  }

  componentWillUnmount() {
    this.props.model.event.remove(this.handler);
  }

  getAddCreativeOprations(model: CreativeOverviewStateContentModel) {
    const hasBindSHop = this.props.model?.creatives.some(
      (item) => item.creativeType === 14,
    );

    const disabledEditAndBindCreative = [
      AdType.MAX_CVR_KEYWORD,
      AdType.KEYWORD,
      AdType.SMART_KEYWORD,
      AdType.RECOMMEND,
    ];

    const disabledByVampaignType = disabledEditAndBindCreative.includes(
      model.campaignInfo?.adType,
    );

    const renderCreateCreativeBtn = () => {
      const createCss = this.cssClassNames(
        'btn',
        'btn-secondary',
        'btn-sm',
        'new',
      );
      return (
        <button
          className={createCss}
          onClick={model.goCreateCreativeFn}
          disabled={hasBindSHop || disabledByVampaignType}
        >
          {i18n.t<string>('creativeOverviewStateContent.buttons.new')}
        </button>
      );
    };

    return (
      <PermissionChecker permissionAware={model.bindPermissionAware}>
        <div className={styles.operationArea}>
          <button
            className={`btn btn-tertiary btn-sm ${styles.bind}`}
            onClick={model.l3ObjectStateFn}
            disabled={hasBindSHop || disabledByVampaignType}
          >
            {i18n.t<string>('creativeOverviewStateContent.buttons.bind')}
          </button>
          {model.showCreateCreativeBtn && renderCreateCreativeBtn()}
          <SearchBar
            model={{
              placeholder: i18n.t<string>(
                'creativeList.placeholders.searchbar',
              ),
              defaultValue: this.props.model.state.searchString,
              search: this.props.model.handleOnSearch,
            }}
          />
        </div>
      </PermissionChecker>
    );
  }

  getChangeCreativeStateOperations(model) {
    const canActive = model.canActive();
    const canDeactive = model.canDeactive();
    const adType = model.campaignInfo?.adType;
    const activeClass = this.cssClassNames('activateBtn', {
      block: !canActive,
    });

    const deactiveClass = this.cssClassNames('deactivateBtn', {
      block: !canDeactive,
    });
    return (
      <div className={styles.batchOperationArea}>
        <Tags
          value={[
            {
              label: i18n.t<string>(
                'creativeOverviewStateContent.tags.selectedTip',
                { count: model.state.selectedCreatives.length },
              ),
              value: model.state.selectedCreatives.length,
            },
          ]}
          onChange={model.handleOnUnSelectAll}
        />
        <div
          className={activeClass}
          onClick={canActive ? model.activeCreatives : undefined}
        >
          {!canActive && (
            <div className={styles.tooltip}>
              {i18n.t<string>(
                'creativeOverviewStateContent.buttons.actionTips',
              )}
            </div>
          )}
          <span>
            {i18n.t<string>('creativeOverviewStateContent.buttons.active')}
          </span>
        </div>
        <div
          className={deactiveClass}
          onClick={canDeactive ? model.deactiveCreatives : undefined}
        >
          {!canDeactive && (
            <div className={styles.tooltip}>
              {adType === AdType.RECOMMEND
                ? i18n.t<string>(
                    'creativeOverviewStateContent.buttons.recommendMinProducts',
                  )
                : i18n.t<string>(
                    'creativeOverviewStateContent.buttons.actionTips',
                  )}
            </div>
          )}
          <span>
            {i18n.t<string>('creativeOverviewStateContent.buttons.deactive')}
          </span>
        </div>
      </div>
    );
  }

  render() {
    const model = this.props.model;
    const state = model.state;
    return (
      <StateDataContext.Consumer>
        {(stateContext: CreativeManagementStateContext) => {
          model.setStateContext(stateContext);
          return (
            <div className={styles.creativeOverviewStateContent}>
              {state.loading && <LoadingIndicator />}
              {model.campaignInfo?.adType === AdType.SHOP
                ? this.getAddCreativeOprations(model)
                : state.selectedCreatives.length > 0 &&
                    model.campaignInfo?.adType !== AdType.RECOMMEND
                  ? this.getChangeCreativeStateOperations(model)
                  : this.getAddCreativeOprations(model)}
              <div className={styles.creatives}>
                <CreativeList model={model.getCreativeListModel()} />
                <div className={styles.buttonArea}>
                  <Button
                    variant='primary'
                    size='sm'
                    onClick={model.closeModalFn}
                  >
                    {i18n.t<string>('common.buttons.close')}
                  </Button>
                </div>
              </div>
            </div>
          );
        }}
      </StateDataContext.Consumer>
    );
  }
}
